import { environment } from '@awpmarine/core/environment';
import { init } from '@plausible-analytics/tracker';

import { env } from '@/env';
import { config } from '@/site-config';

/**
 * Plausible audience analytics, bundled from npm rather than loaded from Plausible's script host,
 * so nothing outside our build runs on the page. Inert when `VITE_PLAUSIBLE_ENDPOINT` is unset.
 */
// Main only: a PR preview would count its visits against the live site.
if (typeof window !== 'undefined' && environment.main && env.VITE_PLAUSIBLE_ENDPOINT) {
  init({ domain: config.domain, endpoint: env.VITE_PLAUSIBLE_ENDPOINT });
}
